
import { defineComponent } from 'vue'
import { useRoute } from 'vue-router'
import { WhitelistedIpsRouteNames } from '@/router/routes-names'

export default defineComponent({
    name: 'view-whitelisted-ips-show',
    async setup () {
        const route = useRoute()
        const whitelistedIP = {
            ip: route.params.ip,
            description: route.params.description,
            creationTime: route.params.creationTime
        }
        return {
            whitelistedIP,
            WhitelistedIpsRouteNames,
            route
        }
    }
})
